import { createReducer } from 'redux-act';
import {
  setIsPointsPay,
  setDateChangeMessaging,
  clearDateChangeMessaging,
  setAppVersion,
  setMapHoveredPropertyId,
  setMapActivePropertyId,
  setPropertyFiltersModalVisible,
} from './uiActions';

const initialState = {
  appOutOfDate: false,
  appVersion: undefined,
  isPointsPay: false,
  mapHoveredPropertyId: undefined,
  mapActivePropertyId: undefined,
  propertyFiltersModalVisible: false,
  dateChangeMessaging: {
    isVisible: false,
  },
};

export const reducer = createReducer(
  {
    [setIsPointsPay]: (state, isPointsPay) => ({ ...state, isPointsPay }),
    [setDateChangeMessaging]: (state, { checkIn, checkOut }) => ({
      ...state,
      dateChangeMessaging: { isVisible: true, checkIn, checkOut },
    }),
    [clearDateChangeMessaging]: (state) => ({ ...state, dateChangeMessaging: { isVisible: false } }),
    [setMapHoveredPropertyId]: (state, mapHoveredPropertyId) => ({ ...state, mapHoveredPropertyId }),
    [setMapActivePropertyId]: (state, mapActivePropertyId) => ({ ...state, mapActivePropertyId }),
    [setPropertyFiltersModalVisible]: (state, propertyFiltersModalVisible) => ({ ...state, propertyFiltersModalVisible }),
    [setAppVersion]: (state, { appVersion, appOutOfDate }) => ({
      ...state,
      appOutOfDate,
      appVersion,
    }),
  },
  initialState,
);
